
import _ from 'lodash'
import ignore from '@/module/ps/ignore'

export default {
  setReslist (state, payload) {
    state.resList = payload
  },
  setAccInfo (state, payload) {
    state.accInfo = payload
  },
  setShowTrue (state, payload) {
    state.showSubApp = payload
  },
  setGlobalParams (state, payload) {
    state.globalParams = _.assign(state.globalParams, payload)
  },
  setReset (state, payload) {
    state.resList = []
    state.token = ''
    state.accInfo = {}
    state.globalParams = {}
  },
  setAppLoading (state, payload) {
    state.appLoading = payload
  },
  setTagViewList (state, payload) {
    if (ignore.includes(payload.path)) return

    const f = _.find(state.tagViewList, ['path', payload.path])

    if (!_.isEmpty(f)) {
      _.assign(f, payload)
    }

    state.tagViewList.push(payload)
    state.tagViewList = _.uniqWith(state.tagViewList, _.isEqual)

    console.log(`[App VueRouter] => 标签数据`, state.tagViewList)
  },
  setArrTagViewList (state, payload) {
    state.tagViewList = payload
  },
  setCurrentTagItem (state, payload) {
    state.currentTagItem = payload
  },
  setCurrentParentPath (state, payload) {
    state.currentParentPath = payload
    console.log(`[App VueRouter] => 父级path`, state.currentParentPath)
  },
  setCurrentMenuData (state, payload) {
    state.currentMenuData = payload
    console.log(`[App VueRouter] => 选中菜单级`, state.currentMenuData)
  },
  setGlobalAnimation (state, payload) {
    state.globalAnimation = payload
  },
  setGlobalInfo (state, payload) {
    state.globalInfo = _.assign(state.globalInfo, payload)
  },
  setCenterStore (state, payload) {
    const { id, stName } = payload
    state.centerStore = _.assign(state.centerStore, {
      id,
      name: stName
    })
  },
  setHelpParams (state, payload) {
    const { reId, reUrl } = payload
    state.helpParams = _.assign(state.helpParams, {
      reId,
      reUrl
    })
  },
  setIsErp (state, payload) {
    state.isErp = Number(payload)
  }
}



// WEBPACK FOOTER //
// ./src/js/conf/home/store/common/mutations.js